import './RecordNameSection.scss';
import { ActiveIndicator } from '@ui/icons';
import { ifClickHandler } from '@lib/events';
import { SonarRecordParent } from '.';
import { SonarText } from '../text';
import { VersionNumber } from '@ui/VersionNumber';
import React, { useMemo } from 'react';

export interface SonarRecordNameSectionProps {
	isActive?: boolean;
	name: string | React.ReactElement | Array<string | React.ReactElement>;
	onClickParent?: () => void;
	parentName?: string;
	removeBold?: boolean;
	showArrow?: boolean;
	versionNumber?: number;
}

export const SonarRecordNameSection: React.FC<SonarRecordNameSectionProps> = ({
	isActive,
	name,
	onClickParent,
	parentName,
	removeBold,
	showArrow,
	versionNumber
}) => {
	const displayName = typeof name === 'string' ?
		<SonarText weight={ removeBold ? undefined : 'semibold' }>{ name }</SonarText> :
		name;

	const handleOnClickParent = useMemo(() => ifClickHandler(onClickParent), [ onClickParent ]);

	return (
		<>
			<SonarRecordParent
				displayName={ parentName as string }
				onClick={ handleOnClickParent }
				showArrow={ showArrow } />
			{ displayName }
			<VersionNumber number={ versionNumber } />
			<ActiveIndicator isActive={ isActive } />
		</>
	);
};
